import * as React from 'react';
import { injectIntl, IntlShape, WrappedComponentProps } from 'react-intl';
import { TranslateType, LMessage, MessageType, DisplayDateType } from '../core/localization/model';
import useFormatMessage from '../core/localization/useFormatMessage';
import { isLocalizationMessage } from '../core/localization/utils';

type IIntl = {
  intl: IntlShape;
  translate: TranslateType;
  displayDate: DisplayDateType;
};

const initialCtx: IIntl = {
  translate: (m: MessageType) => {
    if (isLocalizationMessage(m)) return (m as LMessage).id;
    return m as string;
  },
  displayDate: (d: Date) => new Intl.DateTimeFormat('en-GB').format(d),
} as IIntl;

export const LocaleCtx = React.createContext<IIntl>(initialCtx);

type Props = WrappedComponentProps & React.PropsWithChildren<{}>;
export const LocaleCtxProvider = injectIntl(({ intl, children }: Props) => {
  const { translate } = useFormatMessage(intl.formatMessage);
  const displayDate: DisplayDateType = (d, opt?) => intl.formatDate(d, opt);
  return (
    <LocaleCtx.Provider value={{ intl, translate, displayDate }}>
      {children}
    </LocaleCtx.Provider>
  );
});
